import React from "react";
import { Flex, Box } from "grid-styled";
import Button from "../Button";
import InputContainer from "../forms/InputContainer";
import Select from "../forms/Select";
import moment from "moment";
import { getReport, downloadReport } from "../../api";
import ReportView from "../ReportView";
import CenteredLoader from "../CenteredLoader";

function yearOptions() {
  const startDate = moment().subtract(20, "year");
  const endDate = moment().add(1, "year");
  const values = [];

  while (
    endDate > startDate ||
    endDate.format("YYYY") === startDate.format("YYYY")
  ) {
    let yearValue = startDate.format("YYYY");
    values.push({ value: yearValue, label: yearValue });
    startDate.add(1, "year");
  }

  return values;
}

class MonthlySalesReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloading: false,
      loading: false,
      data: null,
      year: moment().format("YYYY")
    };
  }

  componentDidMount() {
    this.fetchReport();
  }

  getQueryParams() {
    const { year } = this.state;
    return { year };
  }

  fetchReport() {
    this.setState({ loading: true });
    return getReport(
      "monthly_sales_by_franchise",
      this.getQueryParams()
    ).then(report => {
      this.setState({
        data: report,
        loading: false
      });
    });
  }

  handleCSVDownload = evt => {
    evt.preventDefault();
    this.setState({ downloading: true });
    downloadReport("monthly_sales_by_franchise", {
      query: this.getQueryParams(),
      filename: "Monthly Sales by Franchise"
    }).then(() => {
      this.setState({ downloading: false });
    });
  };

  handleYearChange = year => {
    this.setState({ year }, () => {
      this.fetchReport();
    });
  };

  renderReport() {
    const { loading, data } = this.state;
    if (loading) return <CenteredLoader />;
    return data && <ReportView data={data} />;
  }

  render() {
    return (
      <Box p={3}>
        <Flex w={1} pb={3}>
          <Box w={1 / 3}>
            <InputContainer
              name="year"
              labelText="Year"
              dateFormat="YYYY"
              value={this.state.year}
              onChange={this.handleYearChange}
              fieldComponent={Select}
              options={yearOptions()}
              clearable={false}
            />
          </Box>
          <Flex ml="auto" align="flex-end" justify="flex-end">
            <Button onClick={this.handleCSVDownload}>
              {this.state.downloading ? "Downloading CSV..." : "Download CSV"}
            </Button>
          </Flex>
        </Flex>
        {this.renderReport()}
      </Box>
    );
  }
}

export default MonthlySalesReport;



// WEBPACK FOOTER //
// ./src/components/reports/MonthlySalesReport.js